module.exports = __webpack_public_path__ + "img/ico-construction-beginning.97e332dd.svg";